import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  standalone: true,
  selector: 'crm-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  imports: [CommonModule],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerComponent {
  @Input() public text = 'Загрузка...';
  @Input() public top = 'mt-6 pt-6';
  @Input() public bottom = 'mb-2 pb-2';

  @Input() public width = 60;
  @Input() public height = 60;
}
